import { render, staticRenderFns } from "./MasterDataShiftsPage.vue?vue&type=template&id=30d43fbc&scoped=true&lang=pug&"
import script from "./MasterDataShiftsPage.vue?vue&type=script&lang=ts&"
export * from "./MasterDataShiftsPage.vue?vue&type=script&lang=ts&"
import style0 from "./MasterDataShiftsPage.vue?vue&type=style&index=0&id=30d43fbc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d43fbc",
  null
  
)

export default component.exports